import React, { useEffect, useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import _, { debounce } from "lodash";
import { Row, Col, Container } from "reactstrap";
import { SearchableSelectHookForm } from "../../../layout/HookFormInputs";
import {
  userDetails,
  handleDepartmentHeader,
  setLoremIpsum,
  searchNocontentFilter,
} from "../../../../helper";
import { useDispatch, useSelector } from "react-redux";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import {
  EMPTY_DATA,
  defaultPageSize,
  legalDocu,
} from "../../../../config/constants";
import NoContentFound from "../../../common/NoContentFound";
import PopupMsgWrapper from "../../../common/PopupMsgWrapper";
import { PaginationWrapper } from "../../../common/commonPagination";
import {
  addNewLegalDocumenTtype,
  deleteLegalDocument,
  fetchLegalDocuments,
  getDocumentTypeBySelectedCategoryId,
  getLegalDocumentById,
  updateLegalDocumentType,
} from "../Actions/index";
import LoaderCustom from "../../../common/LoaderCustom";
import Toaster from "../../../common/Toaster";
import { getSelectSupplierCategoryService } from "../../VendorNeedForm/Actions";
import { Drawer } from "@material-ui/core";
import FileUploadLegalDocument from "../FileUploadLegalDocument";
import { ApplyPermissionForLegalDocument } from ".";
import { setSelectedRowForPagination } from "../../../simulation/actions/Simulation";
import { resetStatePagination } from "../../../common/Pagination/paginationAction";
import ReactExport from "react-export-excel";
import { LEGAL_DOCUMENT_EXCEL } from "../../../../config/masterData";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const LegalDocumentList = (props) => {
  const permissionsLegalDocument = useContext(ApplyPermissionForLegalDocument);
  const { legalDocumentReducer, loading } = useSelector(
    (state) => state?.LegalDocumentReducer
  );
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [deletedId, setDeletedID] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });
  const [documentTypes, setDocumentTypes] = useState([]);
  const [isoFile, setIsoFile] = useState({});
  const [idForDocument, setIdForDocument] = useState(null);
  console.log('idForDocument: ', idForDocument);
  const [noData, setNoData] = useState(false);
  const [loader, setloader] = useState(false);
  const [categoriesDropDown, setcategoriesDropDown] = useState([]);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [searchSortOrder, setsearchSortOrder] = useState("");
  const [collumnId, setcollumnId] = useState("");
  const [open, setOpen] = useState(false);
  const formController = useForm({ defaultValues: { IsActive: true } });
  const [title, setTitle] = useState(false)

  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = formController;
  const userDetail = userDetails();
  const fetchDocumentTypes = async (selectedCat) => {
    try {
      if (selectedCat) {
        const data = await getDocumentTypeBySelectedCategoryId(selectedCat);
        setDocumentTypes(data?.Data);
        setValue("DocumentType", null);
      }
    } catch (error) {
      // Handle error if needed

    }
  };
  const handleCategoryChange = (selectedOption) => {
    // alert("hello")
    fetchDocumentTypes(selectedOption.value);

    // setSelectedCategory(selectedOption.value);
  };
  const handleCloseDrawer = () => {
    setOpen(false); // Close the drawer
    resetForm(); // Call resetForm function
  };
  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  // const handleIsoCertiicateUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;
  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");

  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG, DOC, DOCX)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "application/msword", // .doc (Word)
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/vnd.ms-excel", // .xls (Excel)www
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
  //         "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
  //         "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
  //       ];

  //       const isTypeValid = allowedFileTypes.includes(file.type);

  //       if (!isTypeValid) {
  //         // Handle the case where the file type is not allowed
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, DOC, or DOCX."
  //         );
  //         return;
  //       }

  //       // Pass file name, base64String, and fileType to setIsoFile
  //       setIsoFile({ fileName: file.name, base64String, fileType: file.type });
  //     };

  //     reader.readAsDataURL(file);
  //   } else {
  //     // Handle the case where the file size exceeds 5 MB
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //   }
  // };
  const handleIsoCertiicateUpload = async (file) => {
    try {
      if (!file) return false;

      // Check for spaces and special characters in filename
      const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
      const hasSpaces = /\s/.test(file.name);

      if (hasSpaces || hasSpecialChars) {
        setIsoFile({});
        setValue('DocumentAttachment', null);
        Toaster.error(
          "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return false;
      }

      // Check file size
      if (file.size > 5 * 1024 * 1024) {
        setIsoFile({});
        setValue('DocumentAttachment', null);
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return false;
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          let base64String = event.target.result;
          base64String = base64String.replace(/^data:(.*?);base64,/, "");

          // Check if the file type is allowed
          const allowedFileTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          ];

          if (!allowedFileTypes.includes(file.type)) {
            setIsoFile({});
            setValue('DocumentAttachment', null);
            Toaster.error(
              "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), PowerPoint (PPT/PPTX)."
            );
            resolve(false);
            return;
          }

          // If all validations pass, set the file
          setIsoFile({
            fileName: file.name,
            base64String,
            fileType: file.type
          });
          resolve(true);
        };

        reader.onerror = () => {
          setIsoFile({});
          setValue('DocumentAttachment', null);
          Toaster.error("Error reading file, please connect with your IT team");
          resolve(false);
        };

        reader.readAsDataURL(file);
      });

    } catch (error) {
      setIsoFile({});
      setValue('DocumentAttachment', null);
      Toaster.error("An error occurred during file upload, please connect with your IT team");
      console.error("File upload error:", error);
      return false;
    }
  };
  const onSubmit = async (data) => {
    setDeleteLoader(true); // Set loading to true during submission
    const userDetail = userDetails();
    const payload = {
      Category: data?.Category?.value,
      DocumentType: data?.DocumentType?.value,
      DocumentAttachment: isoFile?.data ? null : isoFile,
      EmployeeId: parseInt(userDetail?.EmployeeId),
    };

    if (idForDocument) {
      const payloadUpload = {
        ...payload,
        Id: idForDocument,
      };
      dispatch(
        updateLegalDocumentType(payloadUpload, (res) => {
          reset();
          if (res && res.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            setOpen(false);
            setIsoFile("");
            setPageNo(1);
            getUsersWithLoader(
              pageNo,
              defaultPageSize,
              "ASC",
              userDetail?.EmployeeId
            );
          } else {
            Toaster.error(res?.data?.ErrorMessage || "Form submission failed");
          }
        })
      );
    } else {
      dispatch(
        addNewLegalDocumenTtype(payload, (res) => {
          // resetForm();
          if (res && res.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            setPageNo(1);

            getUsersWithLoader(defaultPageSize, "ASC", userDetail?.EmployeeId); // Modified 2to call getUsersWithLoader
            setOpen(false);
            resetForm();
            setIsoFile("");
          } else {
            Toaster.error(res?.Data?.Message || "Form submission failed");
          }
        })
      );
    }
    setTitle(false);
  };

  const getUsersWithLoader = async (
    currentPage,
    pageSize,
    sortOrder,
    employeeId,
    fieldName,
    SearchText
  ) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchLegalDocuments({
          current_page: currentPage,
          per_page: pageSize,
          sortOrder: sortOrder,
          employeeId: parseInt(employeeId),
          sortField: fieldName,
          SearchText: SearchText ? SearchText : "",
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
      setDeleteLoader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      setDeleteLoader(false);
      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  const renderListing = (label) => {
    if (label === "CategoryData") {
      return categoriesDropDown.map((category) => ({
        value: category.Id,
        label: category.Name,
      }));
    }
    if (label === "DocumentType") {
      return documentTypes.map((docTypes) => ({
        value: docTypes.Id,
        label: docTypes.DocumentType,
      }));
    }
  };

  //----listing and adding functions

  const DEBOUNCE_DELAY = 300; // Adjust the delay time as needed

  // Define the debounced function
  const debouncedHandleChange = debounce((value) => {
    // Extract EmployeeId from userDetail object safely
    const EmployeeCode = parseInt(userDetail?.EmployeeId) || 0;

    // Call getUsersWithLoader with updated parameters
    getUsersWithLoader(
      1, // Assuming pageNo starts from 1
      defaultPageSize,
      searchSortOrder,
      EmployeeCode,
      collumnId,
      value
    );

    // Reset necessary states
    setNoData(false);
    gridOptions?.columnApi?.resetColumnState();
    setPageNo(1);
  }, DEBOUNCE_DELAY);

  // Define the handleChange function
  // const handleResetGrid = () => {
  //   // Reset filters
  //   if (gridApi) {
  //     gridApi.setFilterModel(null);
  //   }
  //   // Reset pagination
  //   setPageNo(1);
  //   // Fetch data with default parameters

  //   getUsersWithLoader(1, defaultPageSize, "ASC", "createdOn", null, null);
  // };

  const getSelectSupplierCategory = () => {
    getSelectSupplierCategoryService()
      .then((res) => {
        setcategoriesDropDown(res?.Data);
      })
      .catch(() => { });
  };

  useEffect(() => {
    getSelectSupplierCategory();
    const fetchDataWithDelay = async () => {
      setDeleteLoader(true);
      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 500));
      try {
        // Fetch data after the delay

        const userDetail = userDetails();
        await getUsersWithLoader(
          pageNo,
          defaultPageSize,
          "ASC",
          userDetail?.EmployeeId
        );
        setDeleteLoader(false);
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setDeleteLoader(false);
      }
    };
    // Call fetchDataWithDelay function
    fetchDataWithDelay();
  }, []);
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1600 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };

  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : legalDocumentReducer
          ? legalDocumentReducer
          : [];
    return returnExcelColumn(LEGAL_DOCUMENT_EXCEL, tempArr);
  };

  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={legalDocu}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleDeletePopup = () => {
      setShowPopup(true);
      setDeletedID(props?.data?.ItemGuid);
    };
    const handleEdit = () => {
      setTitle(true);
      const idForDoc = props.data?.Id;
      const idForDocUpdate = props.data?.ItemGuid;
      setIdForDocument(idForDoc);
      if (idForDocUpdate) {
        setloader(true); // Set loader to true when fetching legal document data
        getLegalDocumentById(idForDocUpdate)
          .then(async (res) => {
            const businessData = res?.Data;
            setValue("Category", {
              value: businessData?.Category || "",
              label: businessData?.CategoryName,
            });
            setValue("DocumentType", {
              value: businessData?.DocumentType || "",
              label: businessData?.DocumentTypeName,
            });
            setValue("DocumentAttachment", businessData?.DocumentName);
            setIsoFile({ data: businessData?.DocumentName });
          })
          .catch((_error) => {
            // Handle error if needed
          })
          .finally(() => {
            setloader(false); // Reset loader after fetching legal document data
          });
      } else {
        // If it's a new business type, reset the form and set loader to false
        reset();
        setloader(false);
      }
      // Handle edit action
      // history.push(`/add-business-type?id=${requestId}&mode2=edit`);
      setOpen(true);
    };
    const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
    };

    return (
      <div>
        {permissionsLegalDocument?.Edit && (
          <button
            title="Edit"
            className="Edit mr-2"
            type="button"
            onClick={handleEdit}
          ></button>
        )}
        {permissionsLegalDocument?.Delete && (
          <button
            title="Delete"
            className="Delete hl-delete-icon"
            type="button"
            onClick={handleDeletePopup}
          ></button>
        )}
      </div>
    );
  };
  const resetForm = () => {
    setIsoFile("");
    reset({
      DocumentAttachment: "",
      // Define your form field values to reset here
    });
  };

  const downloadButtonFormatter = (params) => {
    const handleDownload = (file) => {
      if (file) {
        // Create a hidden anchor element to trigger the download
        const link = document.createElement("a");

        if (typeof file === "string") {
          // If it's a string and starts with 'http', assume it's a URL
          link.href = file;
          // } else if (typeof file === 'string') {
          //     // If it's a string, assume it's a base64 string
          //     
          //     return;
          // } else if ('base64String' in file && 'fileType' in file) {
          //     // If it's a DownloadableFile object, use its properties
          //     const blob = base64toBlob(file.base64String, file.fileType);
          //     link.href = URL.createObjectURL(blob);
          // } else if (file instanceof File) {
          //     // If it's a File object, use it directly
          //     link.href = URL.createObjectURL(file);
        } else {
          // Handle other cases or throw an error

          return;
        }

        link.target = "_blank";
        link.download = "downloadedFile";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };

    const documentUrl = params.data?.DocumentUrl;

    return (
      <>
        <button
          title="Download"
          className="hl-upload-btn btn btn-secondary mt-1"
          type="button"
          onClick={() => {
            handleDownload(documentUrl);
          }}
        >
          <div className="download mr-0"></div>
        </button>
      </>
    );
  };

  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };
  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    downloadButtonFormatter: downloadButtonFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  /**
   * @method statusButtonFormatter
   * @description Renders buttons
   */

  const handleDeleteLegalDocument = (documentId) => {
    setDeleteLoader(true); // Set deleteLoader to true to indicate delete operation is in progress

    deleteLegalDocument(documentId, (error, response) => {
      const userDetail = userDetails();
      setDeleteLoader(false); // Set deleteLoader to false once the delete request is complete

      if (error) {

        Toaster.error(error?.response?.data?.ErrorMessage);
        // Handle the error as needed
      } else {
        Toaster.success(response?.data?.Data?.Message);
        // Fetch updated data after deletion
        getUsersWithLoader(
          pageNo,
          defaultPageSize,
          "ASC",
          userDetail?.EmployeeId
        ); // Fetch updated data
      }
    });
  };

  const onPopupConfirm = () => {
    // setIsModalOpen(false);
    setShowPopup(false);
    handleDeleteLegalDocument(deletedId);
  };
  const closePopUp = () => {
    setShowPopup(false);
  };

  const onRejectConfirm = () => {
    setIsModalRejectOpen(false);
  };
  //
  // if (deleteLoader) {
  //   return (
  //     <div>
  //       <LoaderCustom customClass="simulation-Loader" />
  //     </div>
  //   ); // Render loading indicator if loading is true
  // }
  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (legalDocumentReducer.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };
  const cancel = () => {
    setOpen(false);
    resetForm();
    setTitle(false);
  };

  return (
    <>
      {deleteLoader && <LoaderCustom customClass="simulation-Loader hl-loader-fixed" />}
      <div className="bg-white hl-common-page">
        <div>
          <>
            {showPopup && (
              <PopupMsgWrapper
                isOpen={showPopup}
                closePopUp={closePopUp}
                confirmPopup={onPopupConfirm}
                message={`Are you sure you want to delete this item?`}
              />
            )}
            {isModalRejectOpen && (
              <PopupMsgWrapper
                isOpen={isModalRejectOpen}
                closePopUp={closePopUp}
                confirmPopup={onRejectConfirm}
                message={`Are you sure you want to reject this application?`}
              />
            )}
            <>
              <Row className="ag-grid-react without-filter-grid">
                <Col>
                  <div
                    className={`ag-grid-wrapper overlay-contain ${props?.isDataInMaster && !noData
                      ? "master-approval-overlay"
                      : ""
                      } ${(legalDocumentReducer?.data &&
                        legalDocumentReducer.data?.length <= 0) ||
                        noData
                        ? "overlay-contain"
                        : ""
                      }`}
                  >
                    <div
                      className={`ag-theme-material ${loading && "max-loader-height"
                        }`}
                    >
                      {noData && (
                        <NoContentFound
                          title={EMPTY_DATA}
                          customClassName="no-content-found"
                        />
                      )}
                      <Row className="filter-row-large text-start mb-0">
                        <Col md="12" className="mb-3 d-flex justify-content-end">
                          {permissionsLegalDocument?.Add && (
                            <button
                              className="user-btn mr5"
                              title="Add New Legal Document"
                              onClick={() => {
                                setOpen(true);
                                setIdForDocument("")
                              }}
                            >
                              <div className={"plus mr-0"}></div>
                            </button>
                          )}
                          <ExcelFile
                            filename={legalDocu}
                            fileExtension={".xls"}
                            element={
                              <button
                                title={`Download ${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                                type="button"
                                className={"user-btn mr5 Tour_List_Download"}
                              >
                                <div className="download mr-1"></div>
                                {`${state.dataCount === 0
                                  ? "All"
                                  : "(" + state.dataCount + ")"
                                  }`}
                              </button>
                            }
                          >
                            {onBtExport()}

                          </ExcelFile>
                          <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                            <div className="refresh mr-0"></div>
                          </button>
                        </Col>
                      </Row>
                      <div
                        className={`ag-theme-material ${state.isLoader && "max-loader-height"
                          }`}
                      >
                        {state.noData && (
                          <NoContentFound
                            title={EMPTY_DATA}
                            customClassName="no-content-found"
                          />
                        )}
                        {state.isLoader ? (
                          <LoaderCustom customClass="loader-center" />
                        ) : (
                          <AgGridReact
                            defaultColDef={defaultColDef}
                            floatingFilter={true}
                            domLayout="autoHeight"
                            // columnDefs={c}
                            rowData={
                              state.showExtraData && legalDocumentReducer
                                ? [
                                  ...setLoremIpsum(legalDocumentReducer[0]),
                                  ...legalDocumentReducer,
                                ]
                                : legalDocumentReducer
                            }
                            pagination={true}
                            paginationPageSize={defaultPageSize}
                            onGridReady={onGridReady}
                            gridOptions={gridOptions}
                            noRowsOverlayComponent={"customNoRowsOverlay"}
                            noRowsOverlayComponentParams={{
                              title: EMPTY_DATA,
                              imagClass: "imagClass",
                            }}
                            rowSelection={"multiple"}
                            suppressRowClickSelection={true}
                            onSelectionChanged={onRowSelect}
                            onFilterModified={onFloatingFilterChanged}
                            frameworkComponents={frameworkComponents}
                          >
                            <AgGridColumn
                              cellClass="has-checkbox"
                              field="CategoryName"
                              floatingFilter={true}
                              sortable={true}
                              unSortIcon={true}
                              headerName="Category Name"
                            ></AgGridColumn>
                            <AgGridColumn
                              field="DocumentTypeName"
                              floatingFilter={true}
                              headerName="Document Type"
                              sortable={true}
                              unSortIcon={true}
                            ></AgGridColumn>
                            <AgGridColumn
                              headerName="Uploaded Documents"
                              sortable={false}
                              cellRenderer={"downloadButtonFormatter"}
                              floatingFilter={false}
                            ></AgGridColumn>
                            <AgGridColumn
                              field="CreatedBy"
                              floatingFilter={true}
                              sortable={true}
                              unSortIcon={true}
                              headerName="Created By"
                            ></AgGridColumn>
                            <AgGridColumn
                              headerName="Action"
                              sortable={false}
                              cellRenderer={"totalValueRenderer"}
                              type="rightAligned"
                              floatingFilter={false}
                              width={120}
                            ></AgGridColumn>
                          </AgGridReact>
                        )}

                        {
                          <PaginationWrapper
                            gridApi={state.gridApi}
                            setPage={onPageSizeChanged}
                          />
                        }
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
            <Drawer
              open={open}
              anchor="right" // Assuming you want the drawer to open from the right side
              onClose={handleCloseDrawer} // Close the drawer when clicking outside or pressing ESC key
            >
              <Container>
                {loader && <LoaderCustom />}
                <div className={"drawer-wrapper"}>
                  <Row className="drawer-heading">
                    <Col md="12">
                      <div className={"header-wrapper left"}>
                        <h3>{title ? "Update Legal Document" : "Add Legal Document"}</h3>
                      </div>
                      <div
                        onClick={cancel}
                        className={"close-button right"}
                      ></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="part-detail-wrapper hl-filter-inputs pl-3">
                          <Col md="12">
                            <SearchableSelectHookForm
                              {...register("Category")}
                              label={"Category"}
                              name={"Category"}
                              placeholder={"Select"}
                              Controller={Controller}
                              control={control}
                              rules={{ required: true }}
                              handleChange={(value) => {
                                handleCategoryChange(value);
                              }}
                              // handleChange={handleCategoryChange}
                              // register={register}
                              options={renderListing("CategoryData")}
                              mandatory={true}
                              errors={errors.Category}
                              disabled={false}
                            />
                          </Col>
                          <Col md="12">
                            <SearchableSelectHookForm
                              {...register("DocumentType")}
                              label={"Document Type"}
                              name={"DocumentType"}
                              placeholder={"Select"}
                              Controller={Controller}
                              control={control}
                              rules={{ required: true }}
                              // register={register}
                              options={renderListing("DocumentType")}
                              mandatory={true}
                              handleChange={() => { }}
                              errors={errors.DocumentType}
                              disabled={false}
                            />
                          </Col>
                          <Col md="12">
                            <div className="mr-5">
                              <label>
                                Upload Document
                                <span className="asterisk-required">*</span>
                              </label>
                              <FileUploadLegalDocument
                                uploaMainWrap="hl-upload-main"
                                uploadClass="ml-0 hl-upload-mb-0 mt-1"
                                control={control}
                                name="DocumentAttachment"
                                label="Upload ISO Certificate"
                                onFileChange={handleIsoCertiicateUpload}
                                uploadedFile={isoFile?.fileName || isoFile?.data}
                                setUplaodedFile={setIsoFile}
                                {...register("DocumentAttachment", {
                                  required: "This field is required",
                                })}
                                allowedFileTypes={[
                                  "application/pdf",
                                  "application/msword",
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/vnd.ms-excel",
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  "application/vnd.ms-powerpoint",
                                  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                                ]}
                              />
                              {errors.DocumentAttachment && (
                                <span className="text-help">
                                  {errors.DocumentAttachment.message}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col
                            md="12"
                            className="mt-3 justify-content-between d-flex"
                          >
                            <div className="col-sm-12 text-right">
                              <button
                                type={"button"}
                                className="reset mr15 cancel-btn"
                                onClick={cancel}
                              >
                                <div className={"cancel-icon"}></div>
                                {"Cancel"}
                              </button>
                              <button
                                type="submit"
                                className="submit-button save-btn"
                              >
                                <div className="save-icon"></div> {title ? "Update" : "Save"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </Col>
                  </Row>
                </div>
              </Container>
            </Drawer>
          </>
        </div>
      </div>
    </>
  );
};

export default LegalDocumentList;
